module.exports = __webpack_public_path__ + "static/media/Shabnam-Bold.c8b05433.eot";